import React, { useEffect } from 'react';
import './Toast.css';

/**
 * Toast — lightweight notification banner.
 * Props: message, type ('success'|'error'|'info'), onClose, duration (ms, default 4000)
 */
export default function Toast({ message, type = 'info', onClose, duration = 4000 }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [message, onClose, duration]);

  if (!message) return null;

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="polite">
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose} aria-label="Dismiss notification">×</button>
    </div>
  );
}

/**
 * useToast — helper hook for toast state.
 * Returns { toast, showToast, clearToast }
 */
export function useToast() {
  const [toast, setToast] = React.useState(null);
  const showToast = (message, type = 'info') => setToast({ message, type });
  const clearToast = () => setToast(null);
  return { toast, showToast, clearToast };
}
